import React, { useEffect, useState } from 'react';
import styles from '../allEnquiresTab/specificationsTab.module.css';
import styless from '../schedulePOComps/orderdetails.module.css';
import { Container, Grid, Paper, Typography, Button, Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import OrderTable from './OrderTable';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCartOrderdetailsThunk, getPoOrderdetailsThunk } from '../../../../Website/redux/poorderSlice';
import { formateDate } from '../../../../Website/utils/utils';
import PoOrderTable from './PoOrderTable';

const StyledGrid = styled(Grid)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
}));



const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '014px',
    color: '#667085',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    borderRadius: "4px",
    height: "40px",
    fontFamily: `'Public Sans', sans-serif`,
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));

const Orderscomp = ({ tab }) => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const { orders, orderDetails, loading } = useSelector(state => state.poorder)
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate()





    useEffect(() => {
        if (tab == "0") {
            dispatch(getCartOrderdetailsThunk(id))
        } else {
            dispatch(getPoOrderdetailsThunk(id))
        }
    }, [])

    console.log(orderDetails);

    const isprocess = orderDetails?.status == "PROCESSING" || orderDetails?.status == "SHIPPED" || orderDetails?.status == "DELIVERED";
    const isShipped = orderDetails?.status == "SHIPPED" || orderDetails?.status == "DELIVERED";

    const calculateSubtotal = (partList = []) => {
        return partList.reduce((sum, item) => {
            return sum + (item.quotePrice || 0) * (item.quantity || 0);
        }, 0);
    };

    const calculateTotalGst = (partList = []) => {
        return partList.reduce((sum, item) => {
            const lineTotal = (item.quotePrice || 0) * (item.quantity || 0);
            const gstAmount = lineTotal * ((item.gst || 0) / 100);
            return sum + gstAmount;
        }, 0);
    };

    const calculateTotalAmount = (partList = []) => {
        const subtotal = calculateSubtotal(partList);
        const totalGst = calculateTotalGst(partList);

        return subtotal + totalGst;
    };


    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 10, width: '100%' }}>
                <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 35, height: 35 }} />
            </div>
        )
    }
    return (
        <>
            <div className={styles.profilebodyContainer}>
                <div className={styles.profileheader}>
                    <Box display="flex" alignItems="center" >
                        <h2>Order Details</h2>
                        <Typography style={{ margin: '6px' }}>•</Typography>
                        <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>

                            {formateDate(orderDetails?.createdAt)}
                        </Typography>
                        <Typography style={{ margin: '6px' }}>•</Typography>
                        <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#E9BD21' }}>
                            {orderDetails?.products?.length} Products
                        </Typography>
                    </Box>
                    <button className={styles.editbtn} onClick={() => navigate(-1)}>Back to List</button>
                </div>


                <div className={styless.ordetailsbody}>
                    <div className={styless.ordetailsaddress}>
                        {/*  Billing and Shipping Addresses  */}
                        <div className={styless.address_container}>
                            <div className={styless.address_box}>
                                <div className={styless.h3}>Shipping Address</div>
                                <div className={styless.address_deets}>
                                    {tab == "0" ?
                                        <>
                                            <span>{orderDetails?.address?.factoryUnits}</span>
                                            <p>{orderDetails?.address?.streetAddress}. {orderDetails?.address?.state}, {orderDetails?.address?.country} {orderDetails?.address?.zipCode}</p>
                                        </>
                                        :
                                        <>
                                            <span>{orderDetails?.shippingAddress?.factoryUnits}</span>
                                            <p>{orderDetails?.shippingAddress?.streetAddress}. {orderDetails?.shippingAddress?.state}, {orderDetails?.shippingAddress?.country} {orderDetails?.shippingAddress?.zipCode}</p>
                                        </>
                                    }
                                    <p>Email: <br /><span>{orderDetails?.userId?.email}</span></p>
                                    <p>Phone: <br /><span>{orderDetails?.userId?.phone}</span></p>
                                </div>
                            </div>
                        </div>
                        <div className={styless.order_summary}>
                            <div className={styless.order_head}>
                                <div className={styless.h3}>Order ID: <br /><span>#{orderDetails?._id}</span> </div>
                                <Box display="flex" alignItems="center">
                                    <svg width="2" height="40" viewBox="0 0 2 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 0L1 40" stroke="#E6E6E6" />
                                    </svg>
                                </Box>
                            </div>
                            <div className={styless.order_deets}>
                                <p style={{ borderBottom: "1px solid #E6E6E6" }}>Subtotal:
                                    <span>{tab == "0" ? `₹${orderDetails?.priceBreakup?.subTotal.toFixed(2)}` : `₹${calculateSubtotal(orderDetails?.partList).toFixed(2)}`}</span> </p>
                                <p style={{ borderBottom: "1px solid #E6E6E6" }}>Tax: <span>{tab == "0" ? `₹${orderDetails?.priceBreakup?.tax}` : 
                                `₹${calculateTotalGst(orderDetails?.partList)}`}</span></p>
                                <p style={{ borderBottom: "1px solid #E6E6E6" }}>Shipping:<span>Free</span> </p>
                                <p>Total: <span>{tab == "0" ? `₹${orderDetails?.priceBreakup?.total?.toFixed(2)}` : `₹${calculateTotalAmount(orderDetails?.partList)}`}</span></p>
                            </div>
                        </div>
                    </div>

                </div>


                <div className={styless.progress_container}>
                    <div className={`${styless.progress_step} ${styless.active}`}>
                        <div className={styless.circle}>✔</div>
                        <div className={styless.progressmobile} style={{ color: '#2C742F' }}>
                            <p>Order received</p>
                            {/* <small>April 24, 2021 10:30AM</small> */}
                        </div>
                    </div>

                    <div className={`${styless.progress_step} 
                    ${isprocess && styless.active}`}
                    >
                        <div className={styless.circle}>02</div>
                        <div className={styless.progressmobile} style={{ color: isprocess ? "#2C742F" : "#333333" }}>
                            <p>Processing</p>
                            {/* <small>April 24, 2021 5:10PM</small> */}
                        </div>
                    </div>

                    <div className={`${styless.progress_step} ${isShipped && styless.active}`}>
                        <div className={styless.circle}>03</div>
                        <div className={styless.progressmobile} style={{ color: isShipped ? "#2C742F" : "#333333" }}>
                            <p>on the way</p>
                            {/* <small>Expected Soon</small> */}
                        </div>
                    </div>

                    <div className={`${styless.progress_step} ${orderDetails?.status == "DELIVERED" && styless.active}`}>
                        <div className={styless.circle}>04</div>
                        <div className={styless.progressmobile} style={{ color: orderDetails?.status == "DELIVERED" ? "#2C742F" : "#333333" }}>
                            <p>Delivered</p>
                            {/* <small>Expected Soon</small> */}
                        </div>
                    </div>
                </div>
                {
                    tab == "0" ?
                        <OrderTable data={orderDetails?.products} />
                        :
                        <PoOrderTable data={orderDetails?.partList} />
                }
            </div>
        </>
    );
};

export default Orderscomp;
